import LayoutWrapper from "../components/Photos/LayoutWrapper"
import { GalleryDesignProps } from "./types"
import { formatEventDate } from "../utils/formatEventDate"
import PhotographerBar from "./components/PhotographerBar"
import CoverImage from "./components/CoverImage"

/**
 * The original gallery layout: a vendor header above the folder bars and the
 * justified-rows photo grid. Used as the fallback for unknown galleryThemes.
 */
const DefaultGallery = ({
  data,
  folderBar,
  contentMode,
  aiContent,
  emptyContent,
  onCoverLoad,
}: GalleryDesignProps) => {
  const name = data?.name || ""
  const cover = data?.coverPhotoLink
  const dateLabel = formatEventDate(data?.startDate, data?.endDate, data?.date)

  const vendor = data?.vendors?.[0]

  return (
    <>
      {/* Cover hero — cover photo on the left, event name + date on the right */}
      {cover && (
        <div className="relative w-full flex flex-col lg:flex-row lg:h-[100vh]">
          {/* Photographer bar — logo + name top-left, icons top-right of screen */}
          <PhotographerBar vendor={vendor} tone="light" />

          <div className="w-full aspect-[4/5] lg:aspect-auto lg:w-[58%] xl:w-[60%] lg:h-full bg-[#f2f0ee] dark:bg-[#1b1b1b] overflow-hidden">
            <CoverImage
              src={cover}
              alt={name}
              className="w-full h-full object-cover object-center"
              onLoad={onCoverLoad}
            />
          </div>

          <div className="w-full lg:flex-1 flex flex-col justify-center items-center text-center px-6 py-8 lg:py-0 gap-2 lg:gap-4 font-lora">
              <p className="font-cormorant text-newDarkBlack dark:text-brightWhite text-[24px] md:text-[30px] lg:text-[48px]">
                  {name}
              </p>
              {dateLabel && (
                  <div className="flex items-center justify-center gap-3 md:gap-4">
                    <span className="h-px w-8 md:w-12 bg-black/30 dark:bg-white/30" />
                    <p className="font-[300] text-newOffBlack dark:text-offWhite text-sm md:text-base">
                      {dateLabel}
                    </p>
                    <span className="h-px w-8 md:w-12 bg-black/30 dark:bg-white/30" />
                  </div>
              )}
          </div>
        </div>
      )}

      <div className="flex flex-col items-center mt-8 md:mt-12 flex-1">
        {folderBar}

        <div className="w-full gap-2 min-h-[40vh]">
          {contentMode === "ai"
            ? aiContent
            : contentMode === "photos"
            ? <LayoutWrapper />
            : emptyContent}
        </div>
      </div>
    </>
  )
}

export default DefaultGallery
